import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { useAuth } from '@/composables/useAuth'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeaderSpMenu',
  props: {
    isYagiPrime: { type: Boolean, default: false },
    isYagiPrimeCancel: { type: Boolean, default: false }
  },
  setup(__props: any) {



const { user, isAuthenticated } = useAuth()

const userEmail = computed(() => user.value?.email ?? '')

/** 移設元 App.vue の getName 相当 */
const userName = computed(() => {
  const displayName = user.value?.displayName
  if (displayName) return displayName
  const email = userEmail.value
  return email ? email.split('@')[0] : 'ヤギ'
})

/**
 * ヤギディ診断結果。移設元でも値を入れる経路が無く常に null のため、
 * 「あなたのヤギは？」導線だけが出る（挙動そのまま）。
 */
const digramResult = ref<{
  detail_value: { catch_copy_title: string }
} | null>(null)

return { __sfc: true,user, isAuthenticated, userEmail, userName, digramResult }
}

})